// libraries
import { Breadcrumb } from 'antd';
import { useRecoilState } from 'recoil';
import styled from 'styled-components';

// resources
import { txt } from '../../locales/i18n';
import { RouteMatcher, useRouteMatcher } from '../../hooks/bread-crumbs';
import { queryMatchState } from '../../recoil/atoms';

// hooks
import { useDeviceSize } from '../../hooks/device-size';

export function BreadCrumbs(props: { className?: string }): JSX.Element {
	const [queryMatch] = useRecoilState(queryMatchState);
	const routeMatcher: RouteMatcher | null = useRouteMatcher();
	const isMobileDevice: boolean = useDeviceSize();

	if (isMobileDevice === true) {
		return (
			<StyledBreadcrumb className={props.className}>
				<Breadcrumb.Item href={routeMatcher?.baseUrl}>
					{routeMatcher?.name ?? txt('global.not found')}
					{queryMatch !== -1 ? ` (${queryMatch})` : ''}
				</Breadcrumb.Item>
			</StyledBreadcrumb>
		);
	}

	return (
		<StyledBreadcrumb className={props.className}>
			<Breadcrumb.Item href={routeMatcher?.baseUrl}>
				<span className="icon-container">{routeMatcher?.icon}</span>
				<span> </span>
				<span>{routeMatcher?.name ?? txt('global.not found')}</span>
			</Breadcrumb.Item>

			<Breadcrumb.Item>
				<span>
					{routeMatcher?.target ?? ''}
					{queryMatch !== -1 ? ` (${queryMatch})` : ''}
				</span>
			</Breadcrumb.Item>
		</StyledBreadcrumb>
	);
}

const StyledBreadcrumb = styled(Breadcrumb)`
	text-transform: lowercase;

	.icon-container {
		display: inline-block;
	}
`;
